export const applyBlueLightFilter = (isActive: boolean) => {
  try {
    const root = document.documentElement;
    if (isActive) {
      root.style.setProperty('--blue-filter', 'linear-gradient(rgba(255, 248, 220, 0.15), rgba(255, 248, 220, 0.15))');
      root.style.filter = 'sepia(10%) saturate(120%) hue-rotate(-10deg) brightness(105%)';
      document.body.style.background = '#fefcf8';
      document.body.classList.add('blue-light-filter');
    } else {
      root.style.removeProperty('--blue-filter');
      root.style.filter = 'none';
      document.body.style.background = '';
      document.body.classList.remove('blue-light-filter');
    }
  } catch {
    // ignore if DOM not available
  }
};




